import { useState } from "react";
import { Layout } from "antd";
import DepartmentType from "./DepartmentType";
import AddressBookTable from "./AddressBookTable";
import styles from "./index.module.less";
function AddressBookIndex() {
  const [departmentType, setDepartmentType] = useState("all");
  return (
    <Layout className={styles.addressBookIndex}>
      <Layout.Sider className="department-type-container">
        <DepartmentType
          departmentType={departmentType}
          setDepartmentType={setDepartmentType}
        />
      </Layout.Sider>
      <Layout.Content className="address-book-list-container">
        <AddressBookTable departmentType={departmentType} />
      </Layout.Content>
    </Layout>
  );
}

export default AddressBookIndex;
